var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.135,
    height: 18.847,
    viewBox: "0 0 14.135 18.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#343434;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.712,9.423A4.712,4.712,0,1,0,6,4.712a4.712,4.712,0,0,0,4.712,4.712Zm0-7.853A3.141,3.141,0,1,1,7.571,4.712a3.141,3.141,0,0,1,3.141-3.141Z",
    transform: "translate(-0.644 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.068,14A7.075,7.075,0,0,0,3,21.068a.785.785,0,1,0,1.571,0,5.5,5.5,0,1,1,10.994,0,.785.785,0,0,0,1.571,0A7.075,7.075,0,0,0,10.068,14Z",
    transform: "translate(0 -3.006)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrUser);
export default __webpack_public_path__ + "static/media/fi-rr-user.847f88a88bbafb58090273a329809198.svg";
export { ForwardRef as ReactComponent };